import React, { ReactElement } from 'react';

import Icon from 'atomic/icon/icon';

import './about-us.base.scss';

const AboutUsBase: React.FC = (): ReactElement => (
    <div className="about-us">
        <p>
            Jesteśmy wiodącym polskim serwisem internetowym, który stanowi centralne miejsce dla opinii konsumentów
            o sklepach, produktach i firmach. Naszym priorytetem jest wspieranie firm w kształtowaniu pozytywnego
            wizerunku za pomocą autentycznych opinii klientów, które zbieramy po zakończonych transakcjach.
        </p>
        <p>
            W ramach platformy umożliwiamy firmom dostęp do wielu przydatnych narzędzi takich jak: Certyfikat Opineo,
            który podkreśla wysoką jakość obsługi, OpiConnect umożliwiający bezpośrednią komunikację z autorami opinii
            czy System Wiarygodnych Opinii wyróżniający recenzje pochodzące z rzeczywistych zakupów. Dzięki nim budujemy
            zaangażowanie i trwałe relacje pomiędzy firmami a ich klientami.
        </p>

        <div className="about-us__infographic">
            <div className="about-us__infographic-item">
                <Icon icon="smiles-green-dot" className="about-us__infographic-icon" />
                <div className="about-us__infographic-number">
                    18,1
                    {''}
                    <span className="about-us__infographic-unit">
                        mln
                    </span>
                </div>
                <div className="about-us__infographic-description">
                    <strong className="about-us__infographic-keyword">
                        Opinii
                    </strong>
                </div>
            </div>
            <div className="about-us__infographic-item">
                <Icon icon="desktop-green-dot" className="about-us__infographic-icon" />
                <div className="about-us__infographic-number">
                    1,1
                    {''}
                    <span className="about-us__infographic-unit">
                        mln
                    </span>
                </div>
                <div className="about-us__infographic-description">
                    <strong className="about-us__infographic-keyword">
                        Odsłon
                    </strong>
                    <br />
                    {''}
                    miesięcznie
                </div>
            </div>
            <div className="about-us__infographic-item">
                <Icon icon="comment-green-dot" className="about-us__infographic-icon" />
                <div className="about-us__infographic-number">
                    762
                    {''}
                    <span className="about-us__infographic-unit">
                        tys.
                    </span>
                </div>
                <div className="about-us__infographic-description">
                    <strong className="about-us__infographic-keyword">
                        Konsumentów
                    </strong>
                    <br />
                    {''}
                    odwiedzających
                    <br />
                    {''}
                    nas co miesiąc
                </div>
            </div>
            <div className="about-us__infographic-item">
                <Icon icon="shop-green-dot" className="about-us__infographic-icon" />
                <div className="about-us__infographic-number">
                    20
                    {''}
                    <span className="about-us__infographic-unit">
                        tys.
                    </span>
                </div>
                <div className="about-us__infographic-description">
                    <strong className="about-us__infographic-keyword">
                        Współpracujących
                    </strong>
                    <br />
                    {''}
                    firm
                </div>
            </div>
        </div>

        <p>
            W 2018 roku dołączyliśmy do&nbsp;Ringier&nbsp;Axel Springer Polska Sp.&nbsp;z o.o. do którego należą m.in.
            Onet, Newsweek, Fakt, Forbes, Bussines Insider, Skąpiec, Komputer Świat, Przegląd Sportowy. Mamy szeroki zasięg,
            co pozwala naszym Klientom na dotarcie do szerokiego grona odbiorców.
        </p>
        <p>
            Opineo.pl to wiarygodny i rzetelny partner biznesowy.
        </p>
    </div>
);

export default AboutUsBase;
